export const lastApi = "https://www.last.fm/api/";
export const last2_0 = "https://ws.audioscrobbler.com/2.0/";